// extracted by mini-css-extract-plugin
module.exports = {"poweredCon":"style_poweredCon__2O-Jx","text":"style_text__2zRCt","poweredImg":"style_poweredImg__2Owqe"};